exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".monthly-performance[data-v-7d9ea983]{white-space:nowrap}", ""]);

// exports
